import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {finalize} from 'rxjs/operators';
import {environment} from '../../../../../../../environments/environment';
import {ServiceRequestService} from '../../../../../Services/service-request.service';
import {ServiceRequest} from '../../../../../Models/ServiceRequest';
import {InvoiceCustom} from '../../../../../Models/InvoiceCustom';
import {BackOfficeInvoiceService} from '../../../../../Services/invoice.service';
import {InvoiceDealer} from '../../../../../Models/InvoiceDealer';

@Component({
  selector: 'app-reply-step-invoice',
  templateUrl: './reply-step-invoice.component.html',
  styleUrls: ['./reply-step-invoice.component.scss']
})
export class ReplyStepInvoiceComponent implements OnInit {

  @Input() Index;
  @Input() isActive;
  @ViewChild('generateModal', {static: false}) generateModal;
  @ViewChild('downloadLink', {static: false}) downloadLink: ElementRef;
  public dealer?: InvoiceDealer;
  public replyItem;
  public serviceRequest: ServiceRequest = new ServiceRequest();
  public baseUrl = environment.apiUrl;
  public customInvoice = new InvoiceCustom();
  public isPdfDownloading = false;

  constructor(
    private requestService: ServiceRequestService,
    private invoiceService: BackOfficeInvoiceService
  ) {
  }

  ngOnInit() {
    this.requestService.serviceRequest.subscribe(serviceRequest => {
      if (serviceRequest.reply) {
        this.serviceRequest = serviceRequest;
        this.serviceRequest.reply.replyItems = serviceRequest.reply.replyItems.filter(item => !item.solutionStep.restricted);
        this.dealer = serviceRequest.order?.realDealer?.invoiceDealer;
        this.replyItem = this.serviceRequest.reply.replyItems[this.Index];
        this.customInvoice.replyItem = this.replyItem.id;
        if (this.replyItem.replyCreditInvoice && this.replyItem.replyCreditInvoice.creditInvoice) {
          this.customInvoice = this.replyItem.replyCreditInvoice.creditInvoice;
        }
      }
    });
  }

  openGenerateModal() {
    this.generateModal.showDialog();
  }

  updateInvoice(event) {
    this.customInvoice = event;
    this.replyItem.customInvoice = this.customInvoice;
    this.replyItem.isDone = true;
    this.serviceRequest.reply.replyItems[this.Index] = this.replyItem;
    this.confirmStep();
  }

  confirmStep() {
    this.requestService.autoStep({
      serviceRequest: this.serviceRequest.id,
    }).subscribe(res => {
      this.requestService.fetchServiceRequestComplete(this.serviceRequest.id, false);
    });
  }

  openPdfFile() {
    if (this.isPdfDownloading || !this.customInvoice.id) {
      return;
    }

    this.isPdfDownloading = true;
    this.invoiceService.getPdf(this.customInvoice.id).pipe(
      finalize(() => this.isPdfDownloading = false)
    ).subscribe(res => {
      if (res && typeof res === 'object') {
        const el: HTMLElement = this.downloadLink.nativeElement as HTMLElement;
        el.setAttribute('href', res.url);
        el.setAttribute('download', res.filename);
        el.click();
      }
    });
  }

}
